import React from 'react'

const LowerContentDesign = () => (
  <style type="text/css">
    {
      `
      .instruction {
        width: 612px;
        margin: 20px auto;
      }
      .instruction > div {
        padding: 0px 40px;
      }
      .instruction > div:first-child > span {
        color: #333333;
        font-size: 20px;
        font-family: 'Roboto';
        font-weight: normal;
        letter-spacing: 0px;
        line-height: 28px;
      }
      .instruction > div:nth-child(2) {
        margin-top: 20px;
      }
      .bullet {
        margin-top: -9px;
        position: relative;
      }
      .bullet::after {
        content: '';
        position: absolute;
        width: 6px;
        border-left: #000000 2px dashed;
        top: 0px;
        bottom: 0;
        left: 38px;
        margin-left: -3px;
        height: 100%;
      }
      .instruction > div:nth-child(2) > div:nth-child(3) > .bullet::after {
        border: none;
      }
      .step {
        padding-left: 90px;
        padding-bottom: 40px;
        position: relative;
      }
      .step-container > div:nth-child(1) .step {
        background: url('https://cld.partsimg.com/image/upload/f_auto,dpr_auto/carparts/lifetime-replacement/printer') no-repeat;
        background-position-y: top;
        z-index: 1;
      }
      .step-container > div:nth-child(2) .step {
        background: url('https://cld.partsimg.com/image/upload/f_auto,dpr_auto/carparts/lifetime-replacement/package') no-repeat;
        background-position-y: top;
        z-index: 1;
      }
      .step-container > div:nth-child(3) .step {
        background: url('https://cld.partsimg.com/image/upload/f_auto,dpr_auto/carparts/lifetime-replacement/truck') no-repeat;
        background-position-y: top;
        z-index: 1;
      }
      .step > p {
        margin: 9px auto;
      }
      .step > p:first-child > span {
        color: #646464;
        font-size: 16px;
        font-family: 'Roboto';
        font-weight: bold;
        letter-spacing: 0px;
        line-height: 28px;
      }
      .step > p:nth-child(2) > span {
        color: #646464;
        font-size: 14px;
        font-family: 'Roboto';
        font-weight: normal;
        letter-spacing: 0px;
        line-height: 20px;
      }
      .step > p:nth-child(2) > span > span {
        font-weight: bold;
      }
      .step > p:nth-child(3) > span {
        color: #ff4040;
        font-size: 14px;
        font-family: 'Roboto';
        font-weight: normal;
        font-style: italic;
        letter-spacing: 0px;
        line-height: 20px;
      }
      `
    }
  </style>
)

export default LowerContentDesign
